import pluginsPanel from './pluginsPanel';
import slotSelectionPanel from './slotSelectionPanel';
import slotSelectionExtendedPanel from './slotSelectionExtendedPanel';

export { pluginsPanel, slotSelectionPanel, slotSelectionExtendedPanel };
